import React from 'react'
import { Motion, spring } from 'react-motion'
import SwipeableViews from 'react-swipeable-views'
import bindKeyboard from 'react-swipeable-views/lib/bindKeyboard'
import { FloatLeft, FloatRight, ClearBoth, InlineBlockTop, SansSerifDiv, SansSerifSpan, SerifDiv } from './Styles.js'
import { Tooltip } from './Parts.js'
import Modal from './Modal.js'
import Privacy from './Privacy.js'

export default class App extends React.Component {
  render() {
    return (
      <div
          // style={{backgroundColor: `grey`}}
      >
        <div
            style={{
              height: this.state.h,
              maxWidth: this.state.w,
              margin: `0 auto`,
              // position: `absolute`,
            }}
        >
          <NavBar
              mainContent={this.state.mainContent}
              numNotifications={this.state.notifications.length}
              numMessages={this.state.msgs.length}
              toggleOptions={() => this.setState({mainContent: this.state.mainContent === `options` ? `slides` : `options`})}
              toggleAsk={() => this.setState({mainContent: this.state.mainContent === `ask` ? `slides` : `ask`})}
              toggleNotifications={() => this.setState({mainContent: this.state.mainContent === `notifications` ? `slides` : `notifications`})}
              toggleMessages={() => this.setState({mainContent: this.state.mainContent === `messages` ? `slides` : `messages`})}
          />
          {
            this.renderMain()
          }
        </div>
      </div>
    )
  }

  renderMain() {

    switch (this.state.mainContent) {
    case `options`:
      return this.renderOptions()
    case `ask`:
      return this.renderAsk()
    case `notifications`:
      return this.renderNotifications()
    case `messages`:
      return this.renderMessages()
    default:
      return this.renderSlides()
    }
  }

  renderSlides() {
    return (
      <BindKeyboardSwipeableViews
          index={this.state.viewCursor}
          onChangeIndex={(i, iL) => {
            // todo: disable wrapping swipe for keyboards
            if (this.state.freeze) {
              return
            }
            if (i === 3 || i === 7) {
              this.setState({
                notifications: [`foo`],
                msgs: [],
              })
            } else if (i === 4 || i === 8) {
              this.setState({
                notifications: [],
                msgs: [`foo`]
              })
            } else if (i !== 3 && i !== 4 && i !== 7 && i !== 8) {
              this.setState({
                notifications: [],
                msgs: [],
              })
            }
            return this.setState({viewCursor: i})
          }}
      >
        {
          // <MessageView
          //   messages={[this.state.messages[1]]}
          //   questions={this.questions}
          //   choices={this.choices}
          //   metrics={this.metrics}
          //   users={this.users}
          //   reply={msg => this.reply(msg, 1)}
          //   index={0}
          // />
        }
        <View h={this.state.h} w={this.state.w}>
          <SmallTextDiv>
            <p>
              At Aliask, we're solving anti-social networking.
            </p>
            <p>
              Welcome to a simple mock-up of two wander mode interactions.
              Swipe&nbsp;(mobile) or use your keyboard's arrow keys&nbsp;(computer) to move on.
            </p>
            <p>
              Please make sure to answer each question!
              This mock-up is scripted so our conversations can be more useful.
              Nothing's recorded.
            </p>
            <p>
              In our real app, users can skip questions they don't like.
              In this mock-up, this feature remains for illustrative purposes.
            </p>
            <p>Please don't share this: we're not ready for attention.</p>
          </SmallTextDiv>
        </View>
        <QuestionView
            h={this.state.h}
            w={this.state.w}
            question={this.questions[2]}
            choices={this.choices.filter(c => c.qid === 2)}
            answer={id => this.answer(id)}
        />
        <QuestionView
            h={this.state.h}
            w={this.state.w}
            question={this.questions[1]}
            answer={answer => this.fillin(answer, 1)}
            setFreeze={freeze => this.setState({freeze: freeze})}
        />
        <QuestionView
            h={this.state.h}
            w={this.state.w}
            question={this.questions[3]}
            questions={this.questions}
            metrics={this.metrics}
            allChoices={this.choices}
            fillins={this.state.fillins}
            choices={this.choices.filter(c => c.qid === 3)}
            answer={id => this.answer(id)}
            index={3}
        />
        <MatchView
            h={this.state.h}
            w={this.state.w}
            user={this.users[1]}
            index={4}
        />
        <MessageView
            h={this.state.h}
            w={this.state.w}
            messages={[this.state.messages[0]]}
            questions={this.questions}
            choices={this.choices}
            metrics={this.metrics}
            fillins={this.state.fillins}
            users={this.users}
            reply={msg => this.reply(msg, 0)}
            setFreeze={freeze => this.setState({freeze: freeze})}
            index={5}
        />
        <QuestionView
            h={this.state.h}
            w={this.state.w}
            question={this.questions[6]}
            choices={this.choices.filter(c => c.qid === 6)}
            answer={id => this.answer(id)}
        />
        <QuestionView
            h={this.state.h}
            w={this.state.w}
            question={this.questions[7]}
            questions={this.questions}
            metrics={this.metrics}
            allChoices={this.choices}
            fillins={this.state.fillins}
            choices={this.choices.filter(c => c.qid === 7)}
            answer={id => this.answer(id)}
            index={7}
        />
        <MatchView
            h={this.state.h}
            w={this.state.w}
            user={this.users[3]}
            index={8}
        />
        <BlackMessageView
            h={this.state.h}
            w={this.state.w}
            messages={[this.state.messages[1]]}
            questions={this.questions}
            choices={this.choices}
            metrics={this.metrics}
            fillins={this.state.fillins}
            users={this.users}
            reply={msg => this.reply(msg, 1)}
            setFreeze={freeze => this.setState({freeze: freeze})}
            index={9}
        />
        {
          // <QuestionView
          //     h={this.state.h}
          //     w={this.state.w}
          //     question={this.questions[4]}
          //     choices={this.choices.filter(c => c.qid === 4)}
          //     answer={id => this.answer(id)}
          // />
        }
        <View h={this.state.h} w={this.state.w}>
          <SmallTextDiv>
            <p>
              You've reached the end of this mock&#8209;up.
            </p>
            <p>
              Hi, it's Kevin, founder of Aliask.
              I've always been frustrated with the difficulty of networking.
              One-on-one messaging is too much work.
              Broadcasting gets lost in a sea of baby pictures and viral repostings.
            </p>
            <p>
              I don't want to spend time <em>finding people</em> to do stuff.
              I want to spend time <em>doing stuff</em> with people.
              So I'm building Aliask.
            </p>
            <p>
              There's so much more I want to show you!
              One exciting, unshown feature is metrics:
            </p>
            <p>
              Metrics allow users to reduce a set of QnAs to a single number to measure a specific user trait.
              Metrics are another constraint our users will have to focus their interactions.
              For example, a company may want to filter out candidates who cannot achieve a 90 on a Hacker Rank JavaScript Competency metric.
            </p>
            <p>
              If this is interesting to you, you may reach me at <a href="mailto:kevin@codecontest.org">kevin@codecontest.org</a> or 917.834.3092
            </p>
          </SmallTextDiv>
        </View>
      </BindKeyboardSwipeableViews>
    )
  }

  renderOptions() {
    return (
      <SansSerifDiv style={{padding: `50px`}}>
        <MediumTextDiv>Options</MediumTextDiv>
        <SmallTextDiv>
          <p>Click the icon up top (with the square, black border) again to exit Options.</p>
          <p>Elided in this simple mock-up</p>
        </SmallTextDiv>
      </SansSerifDiv>
    )
  }

  renderAsk() {
    return (
      <SansSerifDiv style={{padding: `50px`}}>
        <MediumTextDiv>Ask</MediumTextDiv>
        <SmallTextDiv>
          <p>Click the icon up top (with the square, black border) again to exit Ask.</p>
          <p>Elided in this simple mock-up</p>
          <p>Ask questions! They can be directed to everyone or targeted based on how users answer questions.</p>
        </SmallTextDiv>
      </SansSerifDiv>
    )
  }

  renderNotifications() {
    return (
      <SansSerifDiv style={{padding: `50px`}}>
        <MediumTextDiv>Notifications</MediumTextDiv>
        <SmallTextDiv>
          <p>Click the icon up top (with the square, black border) again to exit Notifications.</p>
          <p>Elided in this simple mock-up</p>
          <p>If your previous answers qualify you to answer a live question, this icon will fill-in.</p>
        </SmallTextDiv>
      </SansSerifDiv>
    )
  }

  renderMessages() {
    return (
      <SansSerifDiv style={{padding: `50px`}}>
        <MediumTextDiv>Messages</MediumTextDiv>
        <SmallTextDiv>
          <p>Click the icon up top (with the square, black border) again to exit Messages.</p>
          <p>Elided for this simple mock-up</p>
          <p>If your previous answers qualify you to receive a message, this icon will fill-in and your message will viewable in the message log here.</p>
        </SmallTextDiv>
      </SansSerifDiv>
    )
  }

  constructor(props) {
    super(props)
    this.renderMain = this.renderMain.bind(this)
    this.renderSlides = this.renderSlides.bind(this)
    this.renderOptions = this.renderOptions.bind(this)
    this.renderAsk = this.renderAsk.bind(this)
    this.renderNotifications = this.renderNotifications.bind(this)
    this.renderMessages = this.renderMessages.bind(this)

    this.questions = [
      {
        id: 0,
        body: `Sex?`,
        privacy: `green`,
        type: `mc`,
      },
      {
        id: 1,
        body: `Zip Code?`,
        privacy: `yellow`,
        type: `fi`,
      },
      {
        id: 2,
        body: `What's your sleeping pattern?`,
        privacy: `yellow`,
        type: `mc`,
      },
      {
        id: 3,
        body: `Need a running partner?`,
        privacy: `green`,
        type: `mc`,
        targeted: true,
        constraints: {
          choices: [2],
        },
      },
      {
        id: 4,
        body: `How should toilet paper be hung?`,
        privacy: `green`,
        type: `mc`,
      },
      {
        id: 5,
        body: `Interested in working at Initech?`,
        privacy: `red`,
        type: `mc`,
      },
      {
        id: 6,
        body: `Do you work at Initech?`,
        privacy: `green`,
        type: `mc`,
      },
      {
        id: 7,
        body: `How do you rate your boss, Bill Lumbergh?`,
        privacy: `red`,
        type: `mc`,
        targeted: true,
        constraints: {
          choices: [11],
        },
      },
    ]

    this.choices = [
      {id: 0, qid: 0, body: `Male`},
      {id: 1, qid: 0, body: `Female`},
      {id: 2, qid: 2, body: `Early bird`},
      {id: 3, qid: 2, body: `Night owl`},
      {id: 4, qid: 2, body: `All-day sloth`},
      {id: 5, qid: 3, body: `Yes`},
      {id: 6, qid: 3, body: `No`},
      {id: 7, qid: 4, body: (<img src="/static/over.png" />)},
      {id: 8, qid: 4, body: (<img src="/static/under.png" />)},
      {id: 9, qid: 5, body: `Yes`},
      {id: 10, qid: 5, body: `No`},
      {id: 11, qid: 6, body: `Yes`},
      {id: 12, qid: 6, body: `No`},
      {id: 13, qid: 7, body: (<span><i className="material-icons" style={{fontSize: `100px`}}>thumb_up</i></span>)},
      {id: 14, qid: 7, body: (<span><i className="material-icons" style={{fontSize: `100px`}}>thumb_down</i></span>)},
    ]

    this.metrics = [
      {id: 0, name: `RackerHank's JavaScript Proficiency Metric`},
      {id: 1, name: `Byer-Miggs' Extraversion Metric`},
    ]

    this.users = [
      {
        first: `John`,
        last: `Doe`,
        username: `jd_is_the_best`,
        imgUrl: `/static/john.jpg`,
      },
      {
        first: `Sarah`,
        last: `Smith`,
        username: `RunForestRun`,
        imgUrl: `/static/sarah.jpg`,
      },
      {
        first: `Bill`,
        last: `Lumbergh`,
        username: `OfficeBill`,
        imgUrl: `/static/anon.png`,
      },
      {
        first: `Anonymous`,
        last: `User`,
        username: `_PsychiatristFightTheatre`,
        imgUrl: `/static/anon.png`,
      },
    ]

    this.state = {
      showOptions: false,
      viewCursor: 0,
      privacy: `red`,
      answers: [],
      fillins: [],
      conversations: [
        [0],
        [1],
      ],
      notifications: [],
      messages: [
        {
          id: 0,
          fromID: 1,
          toID: 0,
          body: `Hey I'm looking for someone to run with in the mornings. I made a resolution to lose twenty pounds this year.`,
          privacy: `green`,
          targeted: true,
          constraints: {
            choices: [2, 5],
          },
        },
        {
          id: 1,
          fromID: 3,
          toID: 0,
          body: `Can you some context to why you rate Mr. Lumbergh so poorly?`,
          privacy: `black`,
          targeted: true,
          constraints: {
            choices: [11, 14],
          },
        },
        {
          id: 2,
          fromID: 2,
          toID: 0,
          body: `Yeah hi, it's Bill Lumbergh, with Initech. We were sort of wondering if you could go ahead and come in Saturday for an interview. That'd be terrific, mmkay?`,
          privacy: `red`,
          targeted: true,
          constraints: {
            choices: [9],
            metrics: [
              {id: 0, rating: 90},
              {id: 1, rating: 70},
            ],
          },
        },
      ],
      msgs: [],
      h: 480,
      w: 320,
    }
  }

  componentDidMount() {
    this.setState({
      h: window.innerHeight,
      w: Math.min(window.innerWidth, 960),
    })
  }

  setPrivacy(p) {
    // this.props.setPrivacy && this.props.setPrivacy(p)
    this.setState({
      privacy: p,
    })
  }

  adjustIcons() {
    if (this.state.viewCursor === 2 || this.state.viewCursor === 6) {
      this.setState({
        notifications: [`foo`],
        msgs: [],
      })
    } else if (this.state.viewCursor === 3 || this.state.viewCursor === 7) {
      this.setState({
        notifications: [],
        msgs: [`foo`],
      })
    } else if (this.state.viewCursor !== 2 && this.state.viewCursor !== 6 && this.state.viewCursor !== 3 && this.state.viewCursor !== 7) {
      this.setState({
        notifications: [],
        msgs: [],
      })
    }
  }

  answer(id) {    
    this.adjustIcons()
    this.setState({
      answers: [
        ...this.state.answers,
        id,
      ],
      viewCursor: this.state.viewCursor + 1,
    })
  }

  fillin(answer, qid) {
    this.adjustIcons()
    this.setState({
      fillins: [
        ...this.state.fillins,
        {
          qid: qid,
          body: answer,
        },
      ],
      viewCursor: this.state.viewCursor + 1,
    })
  }

  reply(msg, conversationID) {
    this.adjustIcons()
    this.setState({
      conversations: [
        ...this.state.conversations.slice(0, conversationID),
        [
          ...this.state.conversations[conversationID],
          this.state.messages.length,
        ],
        ...this.state.conversations.slice(conversationID + 1),
      ],
      messages: [
        ...this.state.messages,
        {
          id: this.state.messages.length,
          ...msg,
        },
      ],
      viewCursor: this.state.viewCursor + 1,
    })
  }
}

const BindKeyboardSwipeableViews = bindKeyboard(SwipeableViews)

class MatchView extends React.Component {
  render() {
    return (
      <View h={this.props.h} w={this.props.w}>
        <div
            style={{
              height: this.props.h - 88,
              display: `flex`,
              flexDirection: `column`,
              justifyContent: `space-around`,
              alignItems: `center`,
            }}
        >
          <MediumTextDiv>You're a match!</MediumTextDiv>
          <div
              style={{
                height: Math.min(this.props.w, this.props.h) * 0.7,
                width: Math.min(this.props.w, this.props.h) * 0.7,
                background: `url(${this.props.user.imgUrl})`,
                backgroundSize: `cover`,
                borderRadius: `25%`,
              }}
          />
          <SmallTextDiv>First name: {this.props.user.first}</SmallTextDiv>
          {
            this.props.user.username[0] !== `_`
            ? <SmallTextDiv>Username: {this.props.user.username}</SmallTextDiv>
            : <SmallTextDiv>
                Username: <Tooltip
                    h={this.props.h}
                    w={this.props.w}
                    index={this.props.index}
                    text={this.props.user.username}
                    tip={
                      <TinyTextDiv>
                        <p>
                          Usernames with a leading underscore (_) are aliasks.
                        </p>
                        <p>
                          Aliasks are auto-generated aliases designed to protect a user's identity, typically for sensitive requests.
                          Any interactions with an aliask will be forwarded to the underlying user.
                        </p>
                        <p>
                          Aliasks are near drop-in replacements for normal users accounts,
                          e.g. you can ask them questions, message them, and add them as a friend.
                          You can even interact with an aliask behind your own aliask.
                        </p>
                        <p>
                          Aliask profiles will have as much information as possible without compromising the underlying user's identity.
                          For example, we wouldn't share the first name if it, combined with existing constraints such as employer, could jeapordize their anonymity.
                        </p>
                      </TinyTextDiv>
                    }
                />
                <TinyTextDiv>^^^^</TinyTextDiv>
                <TinyTextDiv>Tap/hover over me!</TinyTextDiv>
              </SmallTextDiv>
          }
          
        </div>
      </View>
    )
  }

}

class QuestionView extends React.Component {
  render() {
    if (this.props.question.type === `fi`) {
      return (
        <View
            h={this.props.h}
            w={this.props.w}
        >
          <div
              style={{
                height: `100%`,
                display: `flex`,
                flexDirection: `column`,
                justifyContent: `space-between`,
                alignItems: `center`,
              }}
          >
            <div>
              {
                this.props.question.targeted &&
                <div
                    onClick={() => this.showTargetModal()}
                >
                  <img src="/static/bullseye-person.png" height="36px" width="36px" style={{margin: `0 5px`}} />
                  <SmallTextSpan>&lt;-- Click me!</SmallTextSpan>
                  <hr />
                </div>
              }
              <Question h={this.props.h} w={this.props.w} question={this.props.question} />
            </div>
            <div
                style={{
                  width: this.props.w - 20,
                  display: `flex`,
                  justifyContent: `space-around`,
                  alignItems: `center`,
                  minHeight: `50px`,
                }}
            >
              <Privacy
                  privacy={this.state.privacy}
                  setPrivacy={p => this.setState({privacy: p})}
              />
              <div
                  style={{
                    display: `flex`,
                    flexWrap: `wrap`,
                    alignItems: `center`,
                  }}
              >
                <input
                    value={this.state.value}
                    onFocus={() => this.props.setFreeze(true)}
                    onBlur={() => this.props.setFreeze(false)}
                    onKeyDown={e => {
                      if (e.key === `Enter`) {
                        this.props.setFreeze(false)
                        this.props.answer(this.state.value)
                      }
                    }}
                    onChange={e => this.setState({value: e.target.value})}
                    style={{border: `1px solid black`, fontSize: `25px`, maxWidth: this.props.w * 0.7}}
                />
                <button onClick={() => this.props.answer(this.state.value)} style={{fontSize: `25px`}}>Answer</button>              
              </div>
            </div>
            {
              this.state.showModal &&
              <Modal
                  onClose={() => this.setState({showModal: false})}
                  outerStyle={{
                    position: `absolute`,
                    left: this.props.w * this.props.index,
                    // left: 0,
                    right: -1 * this.props.w * this.props.index,
                    // right: -99 * this.props.w * this.props.index,
                  }}
                  innerStyle={{
                    position: `absolute`,
                  }}
              >
                <SmallTextDiv>
                  <p>You've been asked a targeted question!</p>
                  <p>
                    You've been chosen to receive this question because you&nbsp;
                    {
                      this.props.question.constraints.choices && this.props.question.constraints.choices.map((constraintID, i) => <span key={i}>answered <em>{this.props.allChoices[constraintID].body}</em> to <em>{this.props.questions[this.props.allChoices[constraintID].qid].body}</em>, </span>)
                    }
                    {
                      this.props.question.constraints.metrics && this.props.question.constraints.metrics.map((metric, i) => <span key={i}>rated a <em>{metric.rating}</em>+ on the <em>{this.props.metrics[metric.id].name}</em>, </span>)
                    }
                    {
                      this.props.fillins
                      ? <span>and answered <em>{this.props.fillins[this.props.fillins.findIndex(answer => answer.qid === 1)].body}</em> to <em>{this.props.questions[1].body}</em></span>
                      : <span>and answered 10002 to <em>{this.props.questions[1].body}</em></span>
                    }
                    .
                  </p>
                </SmallTextDiv>
              </Modal>
            }
          </div>
        </View>
      )
    }

    return ( // mc default
      <View
          h={this.props.h}
          w={this.props.w}
      >
        <div
            style={{
              height: `100%`,
              display: `flex`,
              flexDirection: `column`,
              justifyContent: `space-between`,
              alignItems: `center`,
            }}
        > 
          <div>
            {
              this.props.question.targeted &&
              <div
                  onClick={() => this.showTargetModal()}
              >
                <img src="/static/bullseye-person.png" height="36px" width="36px" style={{margin: `0 5px`}} />
                <SmallTextSpan>&lt;-- Click me!</SmallTextSpan>
                <hr />
              </div>
            }            
            <Question h={this.props.h} w={this.props.w} question={this.props.question} />
          </div>
          <div
              style={{
                display: `flex`,
                alignItems: `center`,
              }}
          >
            <Privacy
                privacy={this.state.privacy}
                setPrivacy={p => this.setState({privacy: p})}
            />
            <ChoiceList h={this.props.h} w={this.props.w} choices={this.props.choices} answer={choiceID => this.props.answer(choiceID)} />
          </div>
          {
            this.state.showModal &&
            <Modal
                onClose={() => this.setState({showModal: false})}
                outerStyle={{
                  position: `absolute`,
                  left: this.props.w * this.props.index,
                  right: -1 * this.props.w * this.props.index,
                }}
                innerStyle={{
                  position: `absolute`,
                }}
            >
              <SmallTextDiv>
                <p>You've been asked a targeted question!</p>
                <p>
                  You were chosen to receive this question because you&nbsp;
                  {
                    this.props.question.constraints.choices && this.props.question.constraints.choices.map((constraintID, i) => <span key={i}>answered <em>{this.props.allChoices[constraintID].body}</em> to <em>{this.props.questions[this.props.allChoices[constraintID].qid].body}</em>, </span>)
                  }
                  {
                    this.props.question.constraints.metrics && this.props.question.constraints.metrics.map((metric, i) => <span key={i}>rated a <em>{metric.rating}</em>+ on the <em>{this.props.metrics[metric.id].name}</em>, </span>)
                  }
                  {
                    this.props.fillins
                    ? <span>and answered <em>{this.props.fillins[this.props.fillins.findIndex(answer => answer.qid === 1)].body}</em> to <em>{this.props.questions[1].body}</em></span>
                    : <span>and answered 10002 to <em>{this.props.questions[1].body}</em></span>
                  }                  
                  .
                </p>
              </SmallTextDiv>
            </Modal>
          }
        </div>
      </View>
    )
  }

  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      privacy: this.props.question.privacy,
      value: ``,
    }
  }

  showTargetModal() {
    this.setState({showModal: true})
  }
}

class MessageView extends React.Component {
  render() {
    return (
      <View
          h={this.props.h}
          w={this.props.w}
      >
        <div
            style={{
              height: this.props.h - 88,
              display: `flex`,
              flexDirection: `column`,
              justifyContent: `space-between`,
            }}
        >
          <div style={{display: `block`}}>
            {
              this.props.messages[0].targeted &&
              <InlineBlockTop
                  onClick={() => this.showTargetModal()}
              >
                <div 
                    style={{
                      display: `flex`,
                      alignItems: `center`,
                    }}
                >
                  <img src="/static/bullseye-person.png" height="36px" width="36px" style={{margin: `0 5px`}} />
                  <SmallTextSpan>&lt;-- Click me!</SmallTextSpan>
                </div>
              </InlineBlockTop>
            }
            <Message h={this.props.h} w={this.props.w} message={this.props.messages[0]} users={this.props.users} />
            {
              this.state.value &&
              <Message h={this.props.h} w={this.props.w} message={{
                fromID: 0, toID: this.props.messages[0].fromID, privacy: this.state.privacy, body: this.state.value,
              }} users={this.props.users} />
            }
            <ClearBoth />
          </div>
          <div
              style={{
                // minHeight: `36px`,
                display: `flex`,
                justifyContent: `space-around`,
                alignItems: `center`,
              }}
          >
            <FloatLeft>
              <Privacy
                  privacy={this.state.privacy}
                  setPrivacy={p => this.setState({privacy: p})}
              />
            </FloatLeft>
            <div
                style={{
                  display: `flex`,
                  flexWrap: `wrap`,
                  alignItems: `center`,
                }}
            >
              <textarea
                  value={this.state.value}
                  rows="5"
                  onChange={e => this.setState({value: e.target.value})}
                  onFocus={freeze => this.props.setFreeze(true)}
                  onBlur={freeze => this.props.setFreeze(false)}
                  style={{border: `1px solid black`, fontSize: `16px`, minWidth: this.props.w * 0.75, width: this.props.w * 0.75, maxWidth: this.props.w * 0.75}}
              ></textarea>
              <button
                  onClick={() => this.props.reply({
                    fromID: 0,
                    toID: this.props.messages[0].fromID,
                    body: this.state.value,
                    privacy: this.state.privacy,
                  })}
                  style={{fontSize: `25px`}}
              >
                Reply
              </button>
              <ClearBoth />
            </div>
          </div>
          {
            this.state.showModal &&
            <Modal
                onClose={() => this.setState({showModal: false})}
                outerStyle={{
                  position: `absolute`,
                  left: this.props.w * this.props.index,
                  right: -1 * this.props.w * this.props.index,
                }}
                innerStyle={{
                  position: `absolute`,
                }}
            >
              <SmallTextDiv>
                <p>You've been sent a targeted message!</p>
                <p>
                  You were chosen to receive this message because you&nbsp;
                  {
                    this.props.messages[0].constraints.choices && this.props.messages[0].constraints.choices.map((constraintID, i) => <span key={i}>answered <em>{this.props.choices[constraintID].body}</em> to <em>{this.props.questions[this.props.choices[constraintID].qid].body}</em>, </span>)
                  }
                  {
                    this.props.messages[0].constraints.metrics && this.props.messages[0].constraints.metrics.map((metric, i) => <span key={i}>rated a <em>{metric.rating}</em>+ on the <em>{this.props.metrics[metric.id].name}</em>, </span>)
                  }
                  {
                    this.props.fillins
                    ? <span>and answered <em>{this.props.fillins[this.props.fillins.findIndex(answer => answer.qid === 1)].body}</em> to <em>{this.props.questions[1].body}</em></span>
                    : <span>and answered 10002 to <em>{this.props.questions[1].body}</em></span>
                  }
                  .
                </p>
              </SmallTextDiv>
            </Modal>
          }
        </div>
      </View>
    )
  }

  constructor(props) {
    super(props)

    this.state = {
      privacy: this.props.messages[0].privacy,
      showModal: false,
    }
  }

  showTargetModal() {
    this.setState({showModal: true})
  }
}

class BlackMessageView extends React.Component {
  render() {
    return (
      <View
          h={this.props.h}
          w={this.props.w}
      >
        <div
            style={{
              height: this.props.h - 88,
              display: `flex`,
              flexDirection: `column`,
              justifyContent: `space-between`,
            }}
        >
          <div style={{display: `block`}}>
            {
              this.props.messages[0].targeted &&
              <InlineBlockTop
                  onClick={() => this.showTargetModal()}
              >
                <div 
                    style={{
                      display: `flex`,
                      alignItems: `center`,
                    }}
                >
                  <img src="/static/bullseye-person.png" height="36px" width="36px" style={{margin: `0 5px`}} />
                  <SmallTextSpan>&lt;-- Click me!</SmallTextSpan>
                </div>
              </InlineBlockTop>
            }
            <Message h={this.props.h} w={this.props.w} message={this.props.messages[0]} users={this.props.users} />
            {
              this.state.value &&
              <Message h={this.props.h} w={this.props.w} message={{
                fromID: 0, toID: this.props.messages[0].fromID, privacy: this.state.privacy, body: this.state.value,
              }} users={this.props.users} />
            }
            <ClearBoth />
          </div>
          <div
              style={{
                // minHeight: `36px`,
                display: `flex`,
                justifyContent: `space-around`,
                alignItems: `center`,
              }}
          >
            <FloatLeft>
              <Privacy
                  privacy={this.state.privacy}
                  setPrivacy={p => this.setState({privacy: p})}
              />
            </FloatLeft>
            <div
                style={{
                  display: `flex`,
                  flexWrap: `wrap`,
                  alignItems: `center`,
                }}
            >
              <textarea
                  value={this.state.value}
                  rows="5"
                  onChange={e => this.setState({value: e.target.value})}
                  onFocus={freeze => this.props.setFreeze(true)}
                  onBlur={freeze => this.props.setFreeze(false)}
                  style={{border: `1px solid black`, fontSize: `16px`, minWidth: this.props.w * 0.75, width: this.props.w * 0.75, maxWidth: this.props.w * 0.75}}
              ></textarea>
              <button
                  onClick={() => this.props.reply({
                    fromID: 0,
                    toID: this.props.messages[0].fromID,
                    body: this.state.value,
                    privacy: this.state.privacy,
                  })}
                  style={{fontSize: `25px`}}
              >
                Reply
              </button>
              <ClearBoth />
            </div>
          </div>
          {
            this.state.showModal &&
            <Modal
                onClose={() => this.setState({showModal: false})}
                outerStyle={{
                  position: `absolute`,
                  left: this.props.w * this.props.index,
                  right: -1 * this.props.w * this.props.index,
                }}
                innerStyle={{
                  position: `absolute`,
                }}
            >
              <SmallTextDiv>
                <p>You've been sent a targeted message!</p>
                <p>
                  You were chosen to receive this message because you&nbsp;
                  {
                    this.props.messages[0].constraints.choices && this.props.messages[0].constraints.choices.map((constraintID, i) => <span key={i}>answered <em>{this.props.choices[constraintID].body}</em> to <em>{this.props.questions[this.props.choices[constraintID].qid].body}, </em> </span>)
                  }
                  {
                    this.props.fillins
                    ? <span>and answered <em>{this.props.fillins[this.props.fillins.findIndex(answer => answer.qid === 1)].body}</em> to <em>{this.props.questions[1].body}</em></span>
                    : <span>and answered 10002 to <em>{this.props.questions[1].body}</em></span>
                  }.
                </p>
              </SmallTextDiv>
            </Modal>
          }
        </div>
      </View>
    )
  }

  constructor(props) {
    super(props)

    this.state = {
      privacy: this.props.messages[0].privacy,
      showModal: false,
    }
  }

  showTargetModal() {
    this.setState({showModal: true})
  }
}

const Message = ({ message, users, h, w }) => (
  <SmallTextDiv
      style={{
        overflow: `auto`,
      }}
  >
    {
      message.fromID === 0
      ? <div>
          <FloatRight>
            <Privacy privacy={message.privacy} readOnly={true} />
          </FloatRight>
          <SerifDiv
              style={{
                maxWidth: `70%`,
                height: `auto`,
                margin: `1px 1px 25px 1px`,
                padding: `8px 14px`,
                float: `right`,
                backgroundColor: `#81D4FA`,
                borderRadius: `5px`,
              }}
          >
            {message.body}
          </SerifDiv>
          <ClearBoth />
        </div>
      : <div>
          <FloatLeft>
            <Privacy privacy={message.privacy} readOnly={true} />
            {users[message.fromID].first}
          </FloatLeft>
          <SerifDiv
              style={{
                maxWidth: `70%`,
                height: `auto`,
                margin: `1px 1px 25px 1px`,
                padding: `8px 14px`,
                float: `left`,
                backgroundColor: `#FFF59D`,
                borderRadius: `5px`,
              }}
          >
            {message.body}
          </SerifDiv>
          <ClearBoth />
        </div>
    }
    <ClearBoth />
  </SmallTextDiv>
)

const View = ({ children, h, w }) => (
  <div
      style={{
        height: h - 88,
        padding: `10px`,
        maxWidth: w,
        backgroundColor: `white`,
        // position: `absolute`,
      }}
  >
    {children}
  </div>
)

const NavBar = ({mainContent, toggleOptions, toggleAsk, toggleNotifications, toggleMessages, numNotifications, numMessages}) => (
  <div
      style={{
        padding: `5px`,
        backgroundColor: `white`,
      }}
  >
    <div
        style={{
          height: `40px`,
          // maxWidth: (this.props.h / 3 * 4),
          display: `flex`,
          justifyContent: `space-between`,
          alignItems: `center`,
        }}
    >
      <i className="material-icons" onClick={() => toggleOptions()} style={{width: `36px`, maxWidth: `36px`, minWidth: `36px`, fontSize: `36px`, overflow: `hidden`, border: mainContent  === `options` ? `1px solid black` : undefined, cursor: `pointer`}}>settings</i>
      <SansSerifSpan style={{fontSize: `36px`}}>Aliask</SansSerifSpan>
      <span>
        <i className="material-icons" onClick={() => toggleAsk()} style={{width: `36px`, maxWidth: `36px`, minWidth: `36px`, fontSize: `36px`, overflow: `hidden`, border: mainContent  === `ask` ? `1px solid black` : undefined, cursor: `pointer`}}>help</i>
        <i className="material-icons" onClick={() => toggleNotifications()} style={{width: `36px`, maxWidth: `36px`, minWidth: `36px`, fontSize: `36px`, overflow: `hidden`, border: mainContent  === `notifications` ? `1px solid black` : undefined, cursor: `pointer`}}>{numNotifications ? `notifications` : `notifications_none`}</i>
        <i className="material-icons" onClick={() => toggleMessages()} style={{width: `36px`, maxWidth: `36px`, minWidth: `36px`, fontSize: `36px`, overflow: `hidden`, border: mainContent  === `messages` ? `1px solid black` : undefined, cursor: `pointer`}}>{numMessages ? `chat` : `chat_bubble_outline`}</i>
      </span>
    </div>
    <hr />
  </div>
)

const Question = ({ question, h, w }) => (
  <div
      style={{
        width: w - 20,
        maxHeight: h * 0.4,
        display: `flex`,
        flexWrap: `wrap`,
        justifyContent: `center`,
        overflow: `auto`,
      }}
  >
    <MediumTextDiv>
      {question.body}
    </MediumTextDiv>
  </div>
)

const ChoiceList = ({ choices, answer, h, w }) => (
  <div
      style={{
        width: w - 100,
        display: `flex`,
        flexDirection: `column`,
        justifyContent: `center`,
        alignItems: `center`,
        minHeight: h * 0.4,
        maxHeight: h * 0.7,
        overflow: `auto`,
        cursor: `pointer`,
      }}
  >
    {choices.map(choice => <Choice key={choice.id} w={w} onClick={() => answer(choice.id)}>{choice.body}</Choice>)}
  </div>
)

const Choice = ({ children, onClick, h, w }) => (
  <div
      onClick={() => onClick()}
  >
    <SmallTextDiv
        style={{
          minWidth: `100px`,
          marginBottom: `25px`,
          padding: `12px`,
          border: `2px solid black`,
          cursor: `pointer`,
          textAlign: `center`,
          // mineight: `100px`,
          minHeight: `25px`,
          maxWidth: w * 0.8,
          // overflow: `auto`,
        }}
    >
      {children}
    </SmallTextDiv>
  </div>
)

const BigTextDiv = ({ children, style }) => (
  <div style={{fontSize: `36px`, ...style}}>
    {children}
  </div>
)

const BigTextSpan = ({ children, style }) => (
  <span style={{fontSize: `36px`, ...style}}>
    {children}
  </span>
)

const MediumTextDiv = ({ children, style }) => (
  <div style={{fontSize: `24px`, ...style}}>
    {children}
  </div>
)

const MediumTextSpan = ({ children, style }) => (
  <span style={{fontSize: `24px`, ...style}}>
    {children}
  </span>
)

const SmallTextDiv = ({ children, style }) => (
  <div style={{fontSize: `16px`, ...style}}>
    {children}
  </div>
)

const SmallTextSpan = ({ children, style }) => (
  <span style={{fontSize: `16px`, ...style}}>
    {children}
  </span>
)


const TinyTextDiv = ({ children, style }) => (
  <div style={{fontSize: `12px`, ...style}}>
    {children}
  </div>
)

const TinyTextSpan = ({ children, style }) => (
  <span style={{fontSize: `12px`, ...style}}>
    {children}
  </span>
)





// WEBPACK FOOTER //
// ./src/App.js